// HELPERS
import { create_new_time_isostring } from "../../../../helpers/format_time";
// LIBS
import { Google_Analytics_Event } from "../../../../libs/google-analytics";
import { analytics_record } from "../../../../libs/amplify";
// CONFIGS
import config from "../../../../configs/config";
// TYPES
import { User } from "../../../creative/library/types";
import { AdformReportingCreativeData } from "../types";

/**
 * Tracking when Adform report requests are made
 **/
export function requestReportAnalytics(user: User, advertiserId: string, advertiserName: string, scope: string, id: string, name: string, adformReportingCreativeData: AdformReportingCreativeData, selectedMetrics: string[]) {
  Google_Analytics_Event({ name: "report_download", category: "reporting", action: "download", label: id });
  if (config.analytics.DISABLED === false && user.teamId !== "pi6j") {
    analytics_record({
      name: "requestReport",
      attributes: {
        eventType: "click",
        userId: `${user.id}`,
        userEmail: `${user.email}`,
        teamId: `${user.teamId}`,
        teamName: `${user.teamName}`,
        advertiserId: `${scope === "campaign" ? advertiserId : ""}`,
        advertiserName: `${scope === "campaign" ? advertiserName : ""}`,
        creativeId: `${scope === "banner" ? id : ""}`,
        adName: `${scope === "banner" ? name : ""}`,
        brandName: `${adformReportingCreativeData.brandName}`,
        format: `${adformReportingCreativeData.format}`,
        assetType: `${adformReportingCreativeData.hasVideo ? "video" : "image"}`,
        timeStamp: create_new_time_isostring(),
        freeText: `Metrics: ${selectedMetrics.toString()}`,
      },
    });
  }
}
